export default function handler (container, link) {
  if (link.is_article == 1 && link.original) {
    let source = container.querySelector('.news-source'),
        originalText = '',
        wrapper = document.createElement('origin-source') 
    source && source.remove()
    if (link.original == 0) {
      if (link.declaration == 0) {
        originalText = ''
      } else if (link.declaration == 1) {
        originalText = '本文来源：' + link.source + '<br />如无授权请勿二次使用'
      } else {
        originalText = '本文来源：' + link.source + '<br />如有侵权请联系删除'
      }
    } else if (link.original == 1) {
      const poster = link.poster || link.user
      originalText = '本文由小黑盒作者：' + poster.username + '&nbsp;原创'
      if (link.declaration == 1) {
        originalText += '<br />未经授权禁止转载或摘编'
      } else if (link.declaration == 2) {
        originalText += '<br />转载请注明作者及出处'
      }
    }
    wrapper.innerHTML = originalText
    if (!link.link_web_origin_format) {
      container.appendChild(wrapper)
    }
  }
}